









import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import {OptionType} from '@/components/common/types';

/* tslint:disable:no-empty */

@Component({
})
export default class Slider extends Vue {
  @Prop() public readonly options: OptionType[] | undefined;
  @Prop() public readonly selected!: number | string;

  // selected: OptionType | null;
  constructor() {
    super();
  }
  @Emit()
  public emitSelected(selected: OptionType) {
  }
}
